var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-aw",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.7,
    d: "M0 0h288v216H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "scale(2.2222)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#39c",
    d: "M0 0v216h324V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff0",
    d: "M0 144v12h324v-12H0zm0 24v12h324v-12H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m142.7 28 2.9 3-3-3zm-3 6 3 3-3-3m5.9 0 3 3-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m139.7 37 3 2.9-3-3m5.9 0 3 3-3-3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m136.7 42.8 3 3-3-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#c66",
    d: "m142.7 42.8 2.9 3-3-3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m148.6 42.8 2.9 3-3-3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m136.7 45.8 3 3-3-3zm11.9 0 2.9 3-3-3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m139.7 48.7 3 3-3-3m5.9 0 3 3-3-3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m133.8 51.7 3 3-3-3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    stroke: "#fff",
    strokeWidth: 3.7,
    d: "m142.2 34-20.7 78.5L42.8 134l78.4 20.5 21 78.4 20.9-78.4 78.4-21-78.4-20.9-21-78.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m151.5 51.7 3 3-3-3z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m133.8 54.6 3 3-3-3m17.7 0 3 3-3-3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m136.7 57.6 3 3-3-3m11.9 0 2.9 3-3-3z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m130.8 60.5 3 3-3-3z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m137.7 62.5 1 2-1-2m11.8 0 1 2-1-2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m154.5 60.5 3 3-3-3z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m130.8 63.5 3 3-3-3m23.7 0 3 3-3-3z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m133.8 66.4 3 3-3-3m17.7 0 3 3-3-3z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m127.9 69.4 3 3-3-3zm29.5 0 3 3-3-3z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m127.9 72.3 3 3-3-3m29.5 0 3 3-3-3z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m127.9 75.3 3 3-3-3m29.5 0 3 3-3-3z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m125 78.3 2.9 2.9-3-3z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m130.8 78.3 3 2.9-3-3m23.7 0 3 3-3-3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m160.4 78.3 3 2.9-3-3z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m125 81.2 2.9 3-3-3z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m131.8 83.2 1 2-1-2m23.6 0 1 2-1-2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m160.4 81.2 3 3-3-3z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m125 84.2 2.9 3-3-3m35.5 0 3 3-3-3z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m127.9 87.1 3 3-3-3m29.5 0 3 3-3-3z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m122 90 3 3-3-3z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m128.9 92 1 2-1-2m29.5 0 1 2-1-2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m163.3 90 3 3-3-3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m122 93 3 3-3-3m41.3 0 3 3-3-3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m125 96 2.9 3-3-3m35.5 0 3 3-3-3z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m119 99 3 2.9-3-3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m126 100.9.9 2-1-2m35.4 0 1 2-1-2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m166.3 99 3 2.9-3-3z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m119 101.9 3 3-3-3m47.3 0 3 3-3-3z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m122 104.8 3 3-3-3m41.3 0 3 3-3-3z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m116 107.8 3 3-3-3z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m122 107.8 3 3-3-3m41.3 0 3 3-3-3z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m169.2 107.8 3 3-3-3m-62 3 3 2.9-3-3z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m110.2 110.7 3 3-3-3m65 0 2.9 3-3-3z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m178 110.7 3 3-3-3m-79.6 3 3 3-3-3z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m101.3 113.7 3 3-3-3z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m113.1 113.7 3 3-3-3z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m116 113.7 3 3-3-3m53.2 0 3 3-3-3z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m172.2 113.7 3 3-3-3z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m184 113.7 3 3-3-3z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m187 113.7 2.9 3-3-3z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m86.6 116.6 3 3-3-3z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m89.5 116.6 3 3-3-3z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m92.5 116.6 3 3-3-3z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m104.3 116.6 3 3-3-3z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m109.2 117.6 2 1-2-1m67.9 0 2 1-2-1z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m181 116.6 3 3-3-3z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m192.8 116.6 3 3-3-3z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m195.8 116.6 3 3-3-3z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m198.7 116.6 3 3-3-3m-121 3 3 3-3-3z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m80.7 119.6 3 3-3-3z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m83.6 119.6 3 3-3-3z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m95.4 119.6 3 3-3-3z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m100.3 120.6 2 1-2-1m85.6 0 2 1-2-1z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m189.9 119.6 3 3-3-3z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m201.7 119.6 3 3-3-3z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m204.6 119.6 3 3-3-3z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m207.6 119.6 3 3-3-3m-138.8 3 3 2.9-3-3z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m71.8 122.5 3 3-3-3z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m86.6 122.5 3 3-3-3z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m91.5 123.5 2 1-2-1m103.3 0 2 1-2-1z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m198.7 122.5 3 3-3-3z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m213.5 122.5 3 3-3-3z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m216.4 122.5 3 3-3-3z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m60 125.5 3 3-3-3z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m63 125.5 2.9 3-3-3z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m74.8 125.5 2.9 3-3-3zm135.8 0 2.9 3-3-3z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m222.3 125.5 3 3-3-3z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m225.3 125.5 3 3-3-3m-174.2 3 3 2.9-3-3z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m54 128.4 3 3-3-3z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m65.9 128.4 3 3-3-3z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m70.8 129.4 2 1-2-1m144.7 0 2 1-2-1z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m219.4 128.4 3 3-3-3z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m231.2 128.4 3 3-3-3z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m234.2 128.4 3 3-3-3z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m42.3 131.4 3 3-3-3z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m45.2 131.4 3 3-3-3z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m57 131.4 3 3-3-3zm171.3 0 3 3-3-3z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m240 131.4 3 3-3-3z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m243 131.4 3 3-3-3m-206.6 3 3 2.9-3-3z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#c66",
    d: "m51.1 134.3 3 3-3-3zm183 0 3 3-3-3z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m249 134.3 2.9 3-3-3m-206.6 3 3 3-3-3z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m45.2 137.3 3 3-3-3z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m57 137.3 3 3-3-3m171.3 0 3 3-3-3z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m240 137.3 3 3-3-3z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m243 137.3 3 3-3-3z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m51.1 140.3 3 2.9-3-3z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m54 140.3 3 2.9-3-3z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m65.9 140.3 3 2.9-3-3z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m70.8 141.2 2 1-2-1m144.7 0 2 1-2-1z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m219.4 140.3 3 2.9-3-3z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m231.2 140.3 3 2.9-3-3z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m234.2 140.3 3 2.9-3-3m-174.2 3 3 3-3-3z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m63 143.2 2.9 3-3-3z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m74.8 143.2 2.9 3-3-3zm135.8 0 2.9 3-3-3z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m222.3 143.2 3 3-3-3z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m225.3 143.2 3 3-3-3z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m68.8 146.2 3 2.9-3-3z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m71.8 146.2 3 2.9-3-3z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m86.6 146.2 3 2.9-3-3z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m91.5 147.1 2 1-2-1m103.3 0 2 1-2-1z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m198.7 146.2 3 2.9-3-3z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m213.5 146.2 3 2.9-3-3z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m216.4 146.2 3 2.9-3-3m-138.7 3 3 3-3-3z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m80.7 149.1 3 3-3-3z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m83.6 149.1 3 3-3-3z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m95.4 149.1 3 3-3-3z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m100.3 150 2 1-2-1m85.6 0 2 1-2-1z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m189.9 149.1 3 3-3-3z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m201.7 149.1 3 3-3-3z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m204.6 149.1 3 3-3-3z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m207.6 149.1 3 3-3-3m-121 3 2.9 2.9-3-3z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m89.5 152 3 3-3-3z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m92.5 152 3 3-3-3z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m104.3 152 3 3-3-3z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m109.2 153 2 1-2-1m67.9 0 2 1-2-1z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m181 152 3 3-3-3z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m192.8 152 3 3-3-3z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m195.8 152 3 3-3-3z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m198.7 152 3 3-3-3z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m98.4 155 3 3-3-3z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m101.3 155 3 3-3-3z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m113.1 155 3 3-3-3z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m116 155 3 3-3-3m53.2 0 3 3-3-3z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m172.2 155 3 3-3-3z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m184 155 3 3-3-3z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m187 155 2.9 3-3-3m-79.7 3 3 3-3-3z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m110.2 158 3 3-3-3m65 0 2.9 3-3-3z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m178 158 3 3-3-3m-62 3 3 2.9-3-3z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m122 161 3 2.9-3-3m41.3 0 3 3-3-3z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m169.2 161 3 2.9-3-3z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m122 163.9 3 3-3-3m41.3 0 3 3-3-3z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m119 166.8 3 3-3-3z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m126 168.8.9 2-1-2m35.4 0 1 2-1-2z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m166.3 166.8 3 3-3-3z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m119 169.8 3 3-3-3m47.3 0 3 3-3-3z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m125 172.7 2.9 3-3-3m35.5 0 3 3-3-3z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m122 175.7 3 3-3-3z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m128.9 177.6 1 2-1-2m29.5 0 1 2-1-2z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m163.3 175.7 3 3-3-3z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m122 178.6 3 3-3-3m41.3 0 3 3-3-3z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m127.9 181.6 3 3-3-3m29.5 0 3 3-3-3z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m125 184.5 2.9 3-3-3z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m131.8 186.5 1 2-1-2m23.6 0 1 2-1-2z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m160.4 184.5 3 3-3-3z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m125 187.5 2.9 3-3-3m35.5 0 3 3-3-3z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m125 190.4 2.9 3-3-3z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m130.8 190.4 3 3-3-3m23.7 0 3 3-3-3z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m160.4 190.4 3 3-3-3z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#cff",
    d: "m127.9 193.4 3 3-3-3zm29.5 0 3 3-3-3z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m127.9 196.3 3 3-3-3m29.5 0 3 3-3-3z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m127.9 199.3 3 3-3-3m29.5 0 3 3-3-3z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m133.8 202.2 3 3-3-3m17.7 0 3 3-3-3z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m130.8 205.2 3 3-3-3z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#c33",
    d: "m137.7 207.2 1 2-1-2m11.8 0 1 2-1-2z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m154.5 205.2 3 3-3-3z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#69c",
    d: "m130.8 208.2 3 2.9-3-3m23.7 0 3 3-3-3z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m136.7 211.1 3 3-3-3m11.9 0 2.9 3-3-3z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cf",
    d: "m133.8 214 3 3-3-3zm17.7 0 3 3-3-3z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m133.8 217 3 3-3-3m17.7 0 3 3-3-3z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcc",
    d: "m139.7 220 3 3-3-3m5.9 0 3 3-3-3z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m136.7 222.9 3 3-3-3m11.9 0 2.9 3-3-3z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m136.7 225.9 3 3-3-3z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#c66",
    d: "m142.7 225.9 2.9 3-3-3z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#6cc",
    d: "m148.6 225.9 2.9 3-3-3z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccf",
    d: "m139.7 231.8 3 3-3-3m5.9 0 3 3-3-3z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#9cc",
    d: "m139.7 234.7 3 3-3-3m5.9 0 3 3-3-3m-3 6 3 2.9-3-3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAw);
export default __webpack_public_path__ + "static/media/aw.841257eee50ebdf85f75820420c92c47.svg";
export { ForwardRef as ReactComponent };